// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ActionsCell_scroll__jUSqV::-webkit-scrollbar {
  height: 8px;
}
.ActionsCell_scroll__jUSqV::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ActionsCell_scroll__jUSqV::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ActionsCell_ActionsCell__ZfbnW {
  display: flex;
  -webkit-margin-before: 0.18px;
          margin-block-start: 0.18px;
  gap: 10px;
  align-items: flex-end;
  position: absolute;
  cursor: pointer;
  width: -webkit-max-content;
  width: max-content;
  height: 25px;
}
body[dir=ltr] .ActionsCell_ActionsCell__ZfbnW {
  left: 0;
}
body[dir=rtl] .ActionsCell_ActionsCell__ZfbnW {
  right: 0;
}
.ActionsCell_ActionsCell__ZfbnW:only-child {
  -webkit-margin-start: 2.7rem;
          margin-inline-start: 2.7rem;
}
body[dir=ltr] .ActionsCell_ActionsCell__ZfbnW:only-child {
  padding: 3px;
}

.ActionsCell_ActionMr__KHC8Q {
  -webkit-margin-start: 8px !important;
          margin-inline-start: 8px !important;
}

.ActionsCell_actionLoader__wwFu9 {
  position: relative;
  top: -9px;
  margin: 7px;
}

.ActionsCell_regrabLoader__3nNQe {
  position: relative;
  top: -14px;
  margin: 7px;
}

.Toastify {
  width: 100%;
}
.Toastify div {
  max-width: 100%;
  width: -webkit-max-content;
  width: max-content;
  padding: 0 30px;
}
.Toastify span {
  font-size: 12px !important;
  font-family: "LatoRegular", "CairoRegular", sans-serif;
  width: 100%;
}
body[dir=rtl] .Toastify .Toastify__toast-body {
  direction: rtl;
}

.ActionsCell_alignStart__8GHnh {
  -webkit-margin-start: 10px !important;
          margin-inline-start: 10px !important;
}

@media (max-width: 992px) {
  .ActionsCell_ActionMrTop__lhMz5 {
    margin-top: 5px;
  }
}

.ActionsCell_videoMr__b36bI {
  -webkit-margin-start: 3.6em !important;
          margin-inline-start: 3.6em !important;
}
@media (max-width: 992px) {
  .ActionsCell_videoMr__b36bI {
    -webkit-margin-start: 0 !important;
            margin-inline-start: 0 !important;
  }
}

.ActionsCell_versus__Uaxvm {
  width: 25px !important;
}
.ActionsCell_versus__Uaxvm span {
  font-size: 15px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Tables/Cells/ActionsCell/ActionsCell.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EACA,6BAAA;UAAA,0BAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EAOA,0BAAA;EAAA,kBAAA;EAOA,YAAA;AA0CF;AAvDE;EACE,OAAA;AAyDJ;AAvDE;EACE,QAAA;AAyDJ;AAtDE;EAIE,4BAAA;UAAA,2BAAA;AAqDJ;AAxDI;EACE,YAAA;AA0DN;;AApDA;EACE,oCAAA;UAAA,mCAAA;AAuDF;;AApDA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAuDF;;AArDA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AAwDF;;AArDE;EACE,WAAA;AAwDJ;AAvDI;EACE,eAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;AAyDN;AAvDI;ED8DA,0BAAA;EC5DE,sDDSQ;ECRR,WAAA;AAyDN;AArDM;EACE,cAAA;AAuDR;;AAjDA;EACE,qCAAA;UAAA,oCAAA;AAoDF;;AD0CE;EC3FF;IAII,eAAA;EAkDF;AACF;;AAhDA;EACE,sCAAA;UAAA,qCAAA;AAmDF;ADgCE;ECpFF;IAII,kCAAA;YAAA,iCAAA;EAoDF;AACF;;AAlDA;EAEE,sBAAA;AAoDF;AAnDE;EACE,eAAA;EACA,iBAAA;AAqDJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.ActionsCell {\n  display: flex;\n  margin-block-start: 0.18px;\n  gap: 10px;\n  align-items: flex-end;\n  position: absolute;\n  cursor: pointer;\n  #{$ltr} & {\n    left: 0;\n  }\n  #{$rtl} & {\n    right: 0;\n  }\n  width: max-content;\n  &:only-child {\n    #{$ltr} & {\n      padding: 3px;\n    }\n    margin-inline-start: 2.7rem;\n  }\n  height: 25px;\n}\n.ActionMr {\n  margin-inline-start: 8px !important;\n}\n\n.actionLoader {\n  position: relative;\n  top: -9px;\n  margin: 7px;\n}\n.regrabLoader {\n  position: relative;\n  top: -14px;\n  margin: 7px;\n}\n:global {\n  .Toastify {\n    width: 100%;\n    div {\n      max-width: 100%;\n      width: max-content;\n      padding: 0 30px;\n    }\n    span {\n      @include fontSize(12);\n      font-family: $latoRegular;\n      width: 100%;\n    }\n\n    .Toastify__toast-body {\n      #{$rtl} & {\n        direction: rtl;\n      }\n    }\n  }\n}\n\n.alignStart {\n  margin-inline-start: 10px !important;\n}\n\n.ActionMrTop {\n  // margin-top: 10px;\n\n  @include Sm {\n    margin-top: 5px;\n  }\n}\n.videoMr {\n  margin-inline-start: 3.6em !important;\n\n  @include Sm {\n    margin-inline-start: 0 !important;\n  }\n}\n.versus {\n  // margin-inline-end: 12px !important;\n  width: 25px !important;\n  span {\n    font-size: 15px;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ActionsCell_scroll__jUSqV`,
	"ActionsCell": `ActionsCell_ActionsCell__ZfbnW`,
	"ActionMr": `ActionsCell_ActionMr__KHC8Q`,
	"actionLoader": `ActionsCell_actionLoader__wwFu9`,
	"regrabLoader": `ActionsCell_regrabLoader__3nNQe`,
	"alignStart": `ActionsCell_alignStart__8GHnh`,
	"ActionMrTop": `ActionsCell_ActionMrTop__lhMz5`,
	"videoMr": `ActionsCell_videoMr__b36bI`,
	"versus": `ActionsCell_versus__Uaxvm`
};
export default ___CSS_LOADER_EXPORT___;
